
export const environment = {
   production: true,
   apiRoot: 'https://beta-api.attekmi.co/api',
   appRoot: 'https://beta-api.attekmi.co',
   isEnableErrorHandler: 'true',
   apiForLogger: 'https://beta-api.attekmi.co/api/log/error',
   echoKey: 'beta',
   echoHost: 'beta-api.attekmi.co',
   echoPort: '443',
   echoHttps: 'true',

};